var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "InputFieldWithLabel",
    attrs: {
      "role": _vm.inputRole
    }
  }, [_vm.isSearchInput ? _c('span', {
    staticClass: "InputFieldWithLabel-customIcon common-search"
  }) : _vm._e(), _vm.icon ? _c('span', {
    staticClass: "InputFieldWithLabel-customIcon",
    class: _vm.icon
  }) : _vm._e(), (_vm.inputType === 'float' ? 'number' : _vm.inputType) === 'checkbox' ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.currentValue,
      expression: "currentValue"
    }],
    staticClass: "InputFieldWithLabel-input",
    class: _vm.getInputClass,
    attrs: {
      "id": 'js-input-' + _vm.inputId,
      "aria-label": _vm.label,
      "aria-required": _vm.isRequired,
      "autocomplete": _vm.autoComplete ? 'on' : 'off',
      "disabled": _vm.disabled,
      "max": _vm.max,
      "min": _vm.min,
      "readonly": _vm.readonly,
      "step": _vm.inputType === 'float' ? 'any' : '',
      "required": _vm.isRequired,
      "tabindex": "0",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.currentValue) ? _vm._i(_vm.currentValue, null) > -1 : _vm.currentValue
    },
    on: {
      "focus": function ($event) {
        _vm.focused = true;
      },
      "blur": function ($event) {
        _vm.focused = false;
      },
      "keyup": [function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "arrow-down", undefined, $event.key, undefined)) { return null; }
        return _vm.changeFocusToList(0);
      }, function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "arrow-up", undefined, $event.key, undefined)) { return null; }
        return _vm.changeFocusToList(_vm.options.length - 1);
      }],
      "change": function ($event) {
        var $$a = _vm.currentValue,
          $$el = $event.target,
          $$c = $$el.checked ? true : false;
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.currentValue = $$a.concat([$$v]));
          } else {
            $$i > -1 && (_vm.currentValue = $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.currentValue = $$c;
        }
      }
    }
  }) : (_vm.inputType === 'float' ? 'number' : _vm.inputType) === 'radio' ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.currentValue,
      expression: "currentValue"
    }],
    staticClass: "InputFieldWithLabel-input",
    class: _vm.getInputClass,
    attrs: {
      "id": 'js-input-' + _vm.inputId,
      "aria-label": _vm.label,
      "aria-required": _vm.isRequired,
      "autocomplete": _vm.autoComplete ? 'on' : 'off',
      "disabled": _vm.disabled,
      "max": _vm.max,
      "min": _vm.min,
      "readonly": _vm.readonly,
      "step": _vm.inputType === 'float' ? 'any' : '',
      "required": _vm.isRequired,
      "tabindex": "0",
      "type": "radio"
    },
    domProps: {
      "checked": _vm._q(_vm.currentValue, null)
    },
    on: {
      "focus": function ($event) {
        _vm.focused = true;
      },
      "blur": function ($event) {
        _vm.focused = false;
      },
      "keyup": [function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "arrow-down", undefined, $event.key, undefined)) { return null; }
        return _vm.changeFocusToList(0);
      }, function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "arrow-up", undefined, $event.key, undefined)) { return null; }
        return _vm.changeFocusToList(_vm.options.length - 1);
      }],
      "change": function ($event) {
        _vm.currentValue = null;
      }
    }
  }) : _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.currentValue,
      expression: "currentValue"
    }],
    staticClass: "InputFieldWithLabel-input",
    class: _vm.getInputClass,
    attrs: {
      "id": 'js-input-' + _vm.inputId,
      "aria-label": _vm.label,
      "aria-required": _vm.isRequired,
      "autocomplete": _vm.autoComplete ? 'on' : 'off',
      "disabled": _vm.disabled,
      "max": _vm.max,
      "min": _vm.min,
      "readonly": _vm.readonly,
      "step": _vm.inputType === 'float' ? 'any' : '',
      "required": _vm.isRequired,
      "tabindex": "0",
      "type": _vm.inputType === 'float' ? 'number' : _vm.inputType
    },
    domProps: {
      "value": _vm.currentValue
    },
    on: {
      "focus": function ($event) {
        _vm.focused = true;
      },
      "blur": function ($event) {
        _vm.focused = false;
      },
      "keyup": [function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "arrow-down", undefined, $event.key, undefined)) { return null; }
        return _vm.changeFocusToList(0);
      }, function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "arrow-up", undefined, $event.key, undefined)) { return null; }
        return _vm.changeFocusToList(_vm.options.length - 1);
      }],
      "input": function ($event) {
        if ($event.target.composing) { return; }
        _vm.currentValue = $event.target.value;
      }
    }
  }), _c('transition', {
    attrs: {
      "name": "page",
      "mode": "out-in"
    }
  }, [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.readonly && _vm.getCurrentValueNotEmpty,
      expression: "!readonly && getCurrentValueNotEmpty"
    }],
    staticClass: "InputFieldWithLabel-button",
    attrs: {
      "aria-label": _vm.$t('button.clear'),
      "tabindex": _vm.getTabIndexIcon,
      "type": "button"
    },
    on: {
      "click": _vm.clearInputField
    }
  }, [_c('span', {
    staticClass: "InputFieldWithLabel-icon common-cross"
  })])]), _c('label', {
    staticClass: "InputFieldWithLabel-label",
    class: {
      'InputFieldWithLabel-label--withIcon': _vm.isSearchInput || _vm.icon
    },
    attrs: {
      "for": _vm.inputId
    }
  }, [_vm._v(_vm._s(_vm.label) + " "), _vm.isRequired ? _c('span', {
    staticClass: "InputFieldWithLabel-required"
  }, [_vm._v("*")]) : _vm._e()]), _c('div', {
    staticClass: "InputFieldWithLabel-error",
    class: {
      'InputFieldWithLabel-error--displayed': _vm.errorLabel !== ''
    },
    attrs: {
      "id": 'js-error-' + _vm.inputId,
      "aria-label": _vm.errorLabel,
      "tabindex": _vm.getErrorTabIndex
    }
  }, [_vm._v(" " + _vm._s(_vm.errorLabel) + " ")]), _c('div', {
    staticClass: "InputFieldWithLabel-success",
    class: {
      'InputFieldWithLabel-success--displayed': _vm.successLabel !== ''
    },
    attrs: {
      "id": 'js-success-' + _vm.inputId,
      "aria-label": _vm.successLabel,
      "tabindex": _vm.getSuccessTabIndex
    }
  }, [_vm._v(" " + _vm._s(_vm.successLabel) + " ")]), _vm.options ? _c('div', {
    staticClass: "InputFieldWithLabel-optionsContainer"
  }, [_c('input-options', {
    attrs: {
      "avoidFocus": true,
      "isOptionsOpen": _vm.getIsOptionsOpen,
      "selectedIndex": _vm.selectedIndex,
      "items": _vm.options,
      "optionsObject": _vm.optionsObject,
      "value": _vm.value
    },
    on: {
      "input": _vm.optionChanged
    }
  })], 1) : _vm._e()], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }